import http from "@/http-common";

class UserService {
  me() {
    return http.get("/user/me");
  }

  updateOnboardingStatus(isOnboarded) {
    return http.patch("/user/me", { isOnboarded: isOnboarded });
  }

  updateAvatar(avatar) {
    return http.patch("/user/me", { avatar: avatar });
  }

  updateAllowsNotifications(allowsNotifications) {
    return http.patch("/user/me", { allowsNotifications: allowsNotifications });
  }

  muteShop(id) {
    return http.patch(`/user/shop/${id}`, { allowAlerts: false });
  }

  unmuteShop(id) {
    return http.patch(`/user/shop/${id}`, { allowAlerts: true });
  }

  clearBadge(id) {
    return http.patch(`/user/shop/${id}`, { newProductCount: 0 });
  }
}

export default new UserService();
